<template>
  <svg
    width="255"
    height="24"
    viewBox="0 0 255 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_i_23739_25403)">
      <rect width="255" height="24" rx="12" fill="white" />
      <rect
        x="0.5"
        y="0.5"
        width="254"
        height="23"
        rx="11.5"
        stroke="#DEE3E6"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_23739_25403"
        x="0"
        y="0"
        width="255"
        height="25"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_23739_25403"
        />
      </filter>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
